import React, { createContext, useContext } from 'react';
import { useActiveView } from '.';
import ActiveViewScrollManager from './ActiveViewScrollManager';
import { SurveyFormat } from './constants';
import { SurveyFormatProviderProps, UseSurveyFormatReturn, UseActiveViewReturn } from './types';

const SurveyFormatContext = createContext<UseSurveyFormatReturn | null>(null);
SurveyFormatContext.displayName = 'SurveyFormatContext';
const ActiveViewContext = createContext<UseActiveViewReturn | null>(null);

export const useSurveyFormatContext = (): UseSurveyFormatReturn => {
  const context = useContext(SurveyFormatContext);
  if (!context) {
    throw new Error('useSurveyFormatContext must be used within a SurveyFormatProvider');
  }
  return context;
};

export const useActiveViewContext = (): UseActiveViewReturn => useContext(ActiveViewContext) as UseActiveViewReturn;

export const SurveyFormatProvider = ({ children, ...context }: SurveyFormatProviderProps): React.ReactElement => {
  const activeViewContext = useActiveView(context.views);
  const isOQAAT = context.format === SurveyFormat.ONE_QUESTION_AT_A_TIME;
  return (
    <SurveyFormatContext.Provider value={context}>
      <ActiveViewContext.Provider value={activeViewContext}>
        {isOQAAT && <ActiveViewScrollManager />}
        <>{children}</>
      </ActiveViewContext.Provider>
    </SurveyFormatContext.Provider>
  );
};
